export enum Status {
  ARCHIVED,
  SUSPENDED,
  ACTIVATED,
}



// WEBPACK FOOTER //
// ./src/app/models/status.ts